import LabelerSegmentationStore from "./segmentation-store/labelerSegmentationStore";
import LabelerSegmentationUiStore from "./segmentation-store/labelerSegmentationUiStore";
import FabricSegmentationStore from "./segmentation-store/fabricSegmentationStore";
import StickTwoPolygonsStore from "./segmentation-store/stickTwoPolygonsStore";
import LabelVideoStore from "./labelVideoStore";
import ImportLabelsStore from "./import-labels-store/importLabelsStore";
import AnalyseStore from "./analyse-store/analyseStore";

class RootStore {
  public labelerSegmentationStore = new LabelerSegmentationStore(this);
  public labelerSegmentationUiStore = new LabelerSegmentationUiStore(this);
  public fabricSegmentationStore = new FabricSegmentationStore(this);
  public stickTwoPolygonsStore = new StickTwoPolygonsStore(this);
  public labelVideoStore = new LabelVideoStore(this);
  public importLabelsStore = new ImportLabelsStore(this);
  public analyseStore = new AnalyseStore(this);
}

export default RootStore;
